import { fetchFromOldApi } from '~/services/Http';

import { CompanyData, CompanyMessage, SendEmailData } from './types';

export * from './slice';
export * from './types';

// TODO: Delete after change reading from redux
export const getCompanyData = (): Promise<CompanyData> =>
  fetchFromOldApi('/json/company').then((r) => r.json());

export const getCompanyMessage = (): Promise<CompanyMessage> =>
  fetchFromOldApi('/json/company/message').then((r) => r.json());

export const sendMessageToHR = async (message: string, contacts?: string[]) => {
  await fetchFromOldApi('/json/email/user/hr', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      fEmpMessageToHr: message,
      fEmpToMailList: contacts,
    }),
  });
};

export const sendEmail = async (emailData: SendEmailData) => {
  return await fetchFromOldApi('/json/email/group', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(emailData),
  }).then((r) => r.json());
};
